import {FaRegCommentDots} from "react-icons/fa";
import {useEffect, useRef, useState} from "react";
import { motion } from "framer-motion";

export default function Tabs({className, tabs, defaultSelected, onChange, ...props}) {
    const [activeTab, setActiveTab] = useState(defaultSelected ? defaultSelected : tabs[0].key)
    const isFirstRender = useRef(true);


    return (
        <div className={`${className} border-b-[1px] text-sm lg:text-base items-center flex flex-row gap-4  `}>
            {tabs.map((tab, index) => {
                let isActive = activeTab === tab.key
                return (
                    <motion.dev
                        key={index}
                        initial={{
                            scale: 0.9,
                            borderBottomWidth: 0,
                        }}
                        animate={isActive ? {
                            scale: 1,
                            borderBottomWidth: 1,

                        } : {}}

                        transition={{ duration: 0.2 }}

                        onClick={() => {
                            setActiveTab(tab.key)
                            if (onChange) onChange(tab.key)
                        }}

                        className={`flex justify-center items-center text-gray-400 cursor-pointer flex-row gap-2 py-2 border-secondary-900
                         `}>
                        <tab.icon className={isActive && "text-tertiary-900"}/>
                        <p className={`${isActive && "text-black"} whitespace-nowrap`}>
                            {tab.title}
                        </p>
                    </motion.dev>
                )
            })}
        </div>
    )
}